import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles, formatDate } from "../../Services/ReactPDFService.jsx";

// Classic Cover Letter Template Styles - Exact Match to ModalBasedResume Preview
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#ffffff",
    padding: "40 50",
  },
  headerContainer: {
    marginBottom: 24,
    borderBottom: "1pt solid #e1e4e8",
    paddingBottom: 16,
  },
  name: {
    fontSize: 18,
    fontWeight: 700,
    color: "#1a1a1a",
    marginBottom: 8,
  },
  contactInfo: {
    fontSize: 11,
    color: "#555555",
    marginBottom: 4,
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.8,
    color: "#333333",
    textAlign: "justify",
  },
});

const ClassicCoverLetter = ({ coverLetterData }) => {
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header - Exactly matching ModalBasedResume */}
        <View style={styles.headerContainer}>
          <Text style={styles.name}>{name || "[Name]"}</Text>
          <Text style={styles.contactInfo}>
            {email || "[Email]"} | {phone || "[Phone]"}
          </Text>
          <Text style={styles.contactInfo}>{location || "[Location]"}</Text>
        </View>

        {/* Body Content - Preserve formatting exactly as AI generated */}
        <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
      </Page>
    </Document>
  );
};

export default ClassicCoverLetter;
